// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcz_a big_wl","LoadingPlaceholder":"bcz_b big_h","loading-placeholder":"bcz_c"};